/** PostHog gates for iQ onboarding (wizard, chat gate, integrations BFF UI). */

import { POSTHOG } from "@/constants";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";

export interface OnboardingFeatureFlags {
  /** True when either onboarding PostHog flag is on. */
  enabled: boolean;
  /** True once both onboarding flags have resolved (immediate in DEV). */
  loaded: boolean;
  wizardEnabled: boolean;
  chatGateEnabled: boolean;
}

/**
 * Reads `onboarding-wizard-enabled` and `onboarding-chat-gate-enabled`.
 * Either flag ON exposes onboarding UI (`/setup`, integrations data panel, BFF reads).
 * See `POSTHOG.FEATURE_FLAGS` and iq-backend `app/services/feature_flags/keys.py`.
 */
export function useOnboardingFeatureEnabled(): OnboardingFeatureFlags {
  const { enabled: chatGateEnabled, loaded: chatGateLoaded } = useFeatureFlag(
    POSTHOG.FEATURE_FLAGS.ONBOARDING_CHAT_GATE,
  );
  const { enabled: wizardEnabled, loaded: wizardLoaded } = useFeatureFlag(
    POSTHOG.FEATURE_FLAGS.ONBOARDING_WIZARD,
  );

  return {
    enabled: chatGateEnabled || wizardEnabled,
    loaded: chatGateLoaded && wizardLoaded,
    wizardEnabled,
    chatGateEnabled,
  };
}
